var render, staticRenderFns
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=4b5efc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5efc5a",
  null
  
)

export default component.exports